import Foot from "../Components/Footer/footer";
import Head from "../Components/Header/header";
import Gamelanding from "../Components/Product/Gamelanding";

function Gamelandpage() {
  return (
    <>
      <Head />
      <Gamelanding/>
      <Foot />
    </>
  );
}
export default Gamelandpage;
